import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorService } from '../../_services/fundraising/vendor.service';
import { USStates } from '../../_models/USStates';
import { AuthService } from '../../_services/auth.service';
import { forkJoin } from 'rxjs';
import { Location } from '../../_models/fundraising/Location';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';

@Component({
    selector: 'app-location-form',
    templateUrl: './location-form.component.html',
    styleUrls: ['./location-form.component.css']
})

export class LocationFormComponent implements OnInit {

    @Input() formName;
    @Input() parentGroup: FormGroup;
    @Input() locationData: Location;
    @Input() disableForm: boolean;
    @Input() disableSelection: boolean;

    location: FormGroup;

    public locationFormControls(name: string)  {
        return this.location.controls[name];
    }

    public addressFormControls(name: string)  {
        return (this.locationFormControls('address') as FormGroup).controls[name];
    }

    constructor(
        private fb: FormBuilder,
        private vendorService: VendorService,
        private spinner: NgxSpinnerService,
        private authService: AuthService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef)
        { }

    public locations: Location[];
    public states = USStates.abbreviations();

    public getUSState (abrreviation: string) {
      return USStates.getByAbbreviation(abrreviation)
    }
    public statesPairs = USStates.pairs();
    public timeZones = [];


    ngOnInit() {
        this.spinner.show();

        const getLocationsObs = this.vendorService.getVendorLocations();
        const timeZoneObs = this.authService.getAvailableTimeZones();

        forkJoin([
            getLocationsObs,
            timeZoneObs
          ]).subscribe(
            data => {
              this.locations = data[0].filter(l => l.active);
              this.timeZones = data[1];

              const ld = this.locationData;

            const l = this.fb.group({
                locationId: new FormControl(this.locationData?.locationId || -1, Validators.required),
                name: new FormControl(this.locationData?.name, [Validators.required, Validators.maxLength(60)]),
                timeZone: new FormControl(this.locationData?.timeZoneId || 'UTC', [Validators.required, Validators.min(1)]),
                address: new FormGroup({
                    addressLine1: new FormControl(this.locationData?.address?.addressLine1, [Validators.required, Validators.maxLength(60)]),
                    addressLine2: new FormControl(this.locationData?.address?.addressLine2, [Validators.maxLength(60)]),
                    buildingName: new FormControl(this.locationData?.address?.buildingName, [Validators.maxLength(60)]),
                    city: new FormControl(this.locationData?.address?.city, [Validators.required, Validators.maxLength(60)]),
                    stateProvince: new FormControl(this.locationData?.address?.stateProvince || 0, [Validators.required, Validators.min(1), Validators.maxLength(60)]),
                    country: new FormControl('US', [Validators.required, Validators.maxLength(60)]),
                    postalCode: new FormControl(this.locationData?.address?.postalCode, [Validators.required, Validators.maxLength(20)]),
                })
            });

            this.location = l;

                this.parentGroup.addControl('location', this.location);

                this.selectLocation(this.locationData?.locationId);

                this.spinner.hide();
            },
            err => {
              console.error(err);
              this.spinner.hide();
            }
          );
    }

    compare(val1, val2) {
        return val1 === val2;
    }

    selectLocation(locationId) {
        const location = this.locations.find(l => l.locationId === +locationId);
          if (location) {
            this.locationFormControls('name').patchValue(location.name);
            this.locationFormControls('timeZone').patchValue(location.timeZoneId);
            this.addressFormControls('addressLine1').patchValue(location.address?.addressLine1);
            this.addressFormControls('addressLine2').patchValue(location.address?.addressLine2);
            this.addressFormControls('buildingName').patchValue(location.address?.buildingName);
            this.addressFormControls('city').patchValue(location.address?.city);
            this.addressFormControls('country').patchValue(location.address?.country);
            this.addressFormControls('postalCode').patchValue(location.address?.postalCode);
            this.addressFormControls('stateProvince').patchValue(location.address?.stateProvince);


            for (const c in this.location.controls) {
              if (c !== 'locationId' && this.disableForm) {
                this.locationFormControls(c).disable();
              }
            }

            this.location.markAsPristine();
            this.location.updateValueAndValidity();
         } else {

          for (const c in this.location.controls) {
            this.locationFormControls(c)?.enable();
            this.locationFormControls(c)?.patchValue('');
          }

          this.locationFormControls('address')?.reset();
          this.locationFormControls('locationId')?.patchValue(-1);
          this.addressFormControls('stateProvince')?.patchValue(0);
          this.locationFormControls('timeZone')?.patchValue(0);

          this.parentGroup.markAsPristine();
          this.parentGroup.updateValueAndValidity();
         }

         this.addressFormControls('country')?.patchValue('US');
    }

    openLocationInfo() {
        this.dialogService.alert('Station Locations',
        'Station Locations are the physical locations you plan on running your fundraising event and selling tickets. \
        Creating or choosing a location on this page ties events, POS stations, and operators together.', this.viewRef, 'Ok');
    }

}
